import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { Factory, ArrowRight } from 'lucide-react';
import { startOfWeek, endOfWeek, format } from 'date-fns';
import { it } from 'date-fns/locale';
import { opportunitiesAPI } from '../../lib/api';
import { Card, CardContent, CardHeader, CardTitle } from '../ui/card';
import { LateBadge } from './LateBadge';

const fmt = (d) => format(new Date(d), 'EEE d MMM', { locale: it });

export const ProductionWeekCard = () => {
    const [items, setItems] = useState(null);

    useEffect(() => {
        const from = startOfWeek(new Date(), { weekStartsOn: 1 });
        const to = endOfWeek(new Date(), { weekStartsOn: 1 });
        opportunitiesAPI.getAll().then(({ data }) => {
            setItems((data || [])
                .filter(o => (o.kind || 'offerta') !== 'preventivo' && o.production_date)
                .filter(o => { const d = new Date(o.production_date); return d >= from && d <= to; })
                .sort((a, b) => new Date(a.production_date) - new Date(b.production_date)));
        }).catch(() => setItems([]));
    }, []);

    if (items === null) return null;
    return (
        <Card data-testid="dashboard-production-week">
            <CardHeader>
                <CardTitle className="font-heading uppercase text-lg flex items-center gap-2">
                    <Factory size={18} style={{ color: '#064E3B' }} /> In produzione questa settimana
                    <span className="ml-auto text-sm font-normal text-muted-foreground" data-testid="dashboard-production-count">{items.length} {items.length === 1 ? "veicolo" : "veicoli"}</span>
                </CardTitle>
            </CardHeader>
            <CardContent>
                {items.length === 0 ? (
                    <p className="text-sm text-muted-foreground">Nessun veicolo entra in produzione questa settimana.</p>
                ) : (
                    <div className="divide-y">
                        {items.map(o => (
                            <Link
                                key={o.id}
                                to={`/pipeline?offer=${o.id}`}
                                className="group flex flex-wrap items-center gap-x-4 gap-y-1 py-2 text-sm hover:bg-muted/40 px-2 -mx-2 rounded-sm transition-colors"
                                data-testid={`dashboard-production-item-${o.id}`}
                            >
                                <span className="w-24 shrink-0 font-semibold capitalize" style={{ color: '#064E3B' }}>{fmt(o.production_date)}</span>
                                <span className="font-medium">{o.title}</span>
                                {o.commessa && <span className="text-xs text-muted-foreground">Commessa: <b className="text-foreground">{o.commessa}</b></span>}
                                {o.telaio && <span className="text-xs text-muted-foreground">Telaio: <b className="text-foreground">{o.telaio}</b></span>}
                                {o.delivery_date && <span className="text-xs text-muted-foreground">Consegna: <b className="text-foreground">{format(new Date(o.delivery_date), 'dd/MM/yyyy')}</b></span>}
                                <LateBadge opp={o} testId={`dashboard-production-late-${o.id}`} />
                                <ArrowRight size={14} className="ml-auto text-muted-foreground group-hover:translate-x-0.5 transition-transform" />
                            </Link>
                        ))}
                    </div>
                )}
            </CardContent>
        </Card>
    );
};
